import { Link } from "react-router-dom";
import { Clock, Sparkles } from "lucide-react";
import { bookUrl } from "../data/siteConfig";

export const ServiceCard = ({ service, onSelect }) => (
  <article
    className="card-glow-hover group overflow-hidden rounded-2xl border border-white/10 bg-coal"
    data-testid={`service-card-${service.id}`}
  >
    <button
      type="button"
      onClick={() => onSelect?.(service)}
      className="relative block aspect-[4/5] w-full overflow-hidden text-left"
      aria-label={`View ${service.name} details`}
    >
      <img
        src={service.image}
        alt={`${service.name} example`}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
      />
      <span className="absolute left-3 top-3 rounded-full bg-black/70 px-3 py-1 text-xs font-bold text-hotpink backdrop-blur">
        ${service.price}+
      </span>
      {service.hairIncluded && (
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-hotpink/90 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-white">
          <Sparkles className="h-3 w-3" /> Hair Included
        </span>
      )}
    </button>

    <div className="p-5">
      <h3 className="font-serif text-xl">{service.name}</h3>
      <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-white/55">
        {service.short}
      </p>
      <div className="mt-3 flex items-center gap-2 text-xs text-white/45">
        <Clock className="h-3.5 w-3.5 text-hotpink/70" />
        {service.duration}
        <span className="text-white/25">•</span>
        <span>{service.hairNote}</span>
      </div>
      <div className="mt-5 flex items-center justify-between">
        <p className="text-sm text-white/60">
          Starting at{" "}
          <span className="font-serif text-lg font-bold text-white">
            ${service.price}
          </span>
        </p>
        <Link
          to={bookUrl(service.id)}
          data-testid={`service-book-${service.id}`}
          className="rounded-full border border-hotpink px-5 py-2 text-[10px] font-bold uppercase tracking-[0.2em] text-hotpink transition-colors duration-300 hover:bg-hotpink hover:text-white"
        >
          Book
        </Link>
      </div>
    </div>
  </article>
);

